// extracted by mini-css-extract-plugin
export default {"code__barCode":"Code_code__barCode__m1hmQ"};